export const pageTestIds = {
  home: 'page-home',
  login: 'page-login',
  consultations: 'page-consultations',
  profile: 'page-profile',
  knowledgeCenter: 'page-knowledge-center',
  navigator: 'page-navigator',
  serviceProviders: 'page-service-providers',
  budget: 'page-budget',
} as const
